import css from 'styled-jsx/css'

import { colors, sizes } from '../../../theme'
import common from '../../../theme/common'


export default css`
.contact {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  height: 40rem;
}

.contact .arrow {
  display: none;
  text-align: right;
  margin-right: 5rem;
  margin-top: 7rem;
  width: 100%;
}

.contact .arrow img {
  width: 3.5rem;
}

.contact :global(.content) {
  display: flex;
  width: 100%;
  max-width: 100rem;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
  z-index: 1;
  text-decoration: none;
}

.contact :global(.content:hover) {
  cursor: url('/images/icons/curseur-128.png'), auto;
 
}

.contact :global(.baseline) {
  font-family: 'Taviraj-Light', serif;
  font-size: 7rem;
  color: ${colors.pureWhite};
  text-align:center;
  margin: 0.5rem;
  width:100%;
  padding-bottom:3rem;
}

.contact :global(.bulb) {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.contact :global(.text) {
  ${common.text};

  margin-top: 2rem;
  max-width: 60rem;
  font-family: 'Open Sans Regular', sans-serif;
  color: ${colors.darkerGrey};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.contact :global(.text span) {
  white-space: pre;
}

.contact :global(.text a) {
  display: inline;
  white-space: nowrap;
  text-decoration: none;
  font-family: 'Open Sans Bold', sans-serif;
  color: ${colors.governorBayBlue};
}

.contact :global(.option) {
  ${common.text};

  margin-top: 2rem;
  text-transform: uppercase;
  font-family: 'Open Sans Regular', sans-serif;
  color: ${colors.darkerGrey};
}

.contact :global(.text div:first-child) {
  text-transform: uppercase;
}

.contact :global(.text div + div) {
  margin-top: 2rem;
}

.contact :global(.write-button) {
  margin-top: 2rem;
  margin-bottom: 8rem;
  min-width: 50rem;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .contact {
    min-width: auto;
    height: 25rem;
  }

  .contact .arrow {
    display: flex;
    justify-content: flex-end;
  }

  .contact :global(.baseline) {
    font-size: 4rem;
    position: relative;
    padding-bottom:0;
  }

  .contact :global(.write-button) {
    width: 100%;
    min-width: auto;
  }
}

@media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
  .contact :global(.baseline) {
    font-size: 4rem;
    padding-bottom:0;
  }

  .contact :global(.highlighted-text) {
    line-height: 4.5rem;
  }
}
`
